module.exports = __webpack_public_path__ + "img/00.68451532.jpg";